import screenProps from '../../../screenProps'
import { getSubInvoices } from '../../../../../HttpRequests/subInvoices'
import { setSubInvoices } from '../State/subInvoices'
import { startFetching, finishFetching } from '../State/fetching'
import handleException from '../../../../../Core/Helpers/handleException'

export default () => async (dispatch, getState) => {

  const { id } = screenProps().match.params

  const state = getState()

  const { filters } = state.screens.SubProject

  const { search, sorting } = state.screens.SubProject.SubInvoices

  const params = {
    search,
    'filter[subcontractor_id]': id,
    'filter[project_status_key]': filters.projectStatusKey || undefined,
    'filter[project_id]': filters.projectId || undefined,
    sort: sorting.order ? `${sorting.order === 'descend' ? '-' : ''}${sorting.columnKey}` : '-date',
    include: [
      'user',
    ].join(','),
  }

  dispatch(startFetching())

  try {

    const response = await getSubInvoices({ params })

    dispatch(setSubInvoices(response.data))

  } catch (error) {

    handleException(error)

  } finally {

    dispatch(finishFetching())

  }

}
